import React from "react";
import "./Construction.css";

function Construction() {
  return (
    <div className="page-con-full">
      <h1>Page is Under Construction</h1>
    </div>
  );
}
export default Construction;
